import React from "react";
import PropTypes from "prop-types";
import numberToWord from "../../components/common/utlity/invoiceword";
import { useTranslation } from "react-i18next";
import { Country, State } from "country-state-city";
import {
  calculateTotalGST,
  calculateTotalGSTAmount,
  calculateTotalGSTPercentage,
} from "./invoice.utility";
import {
  SaleformatDateByBusinessPreference,
  truncateCommaSeparatedString,
} from "../../components/common/utlity/utility";
import { AWS_URL } from "../../services/http.service";
const TallyPrime = ({
  containerRef,
  businessName,
  phone,
  item,
  bussiness,
  darkMode = false,
}) => {
  const { t } = useTranslation();
  const amountInwords = numberToWord(item?.transactionAmount);
  const styles = {
  container: {
    margin: 0,
    padding: 0,
    textIndent: 0,
    fontFamily: "Calibri, sans-serif",
    color: "#424242",
    backgroundColor: "#eff6ff",
  },
  title: {
    fontSize: "19.5pt",
    textAlign: "center",
    marginBottom: "20px",
  },
  heading: {
    fontSize: "24pt",
  },
  normalText: {
    fontSize: "9.5pt",
  },
  boldText: {
    fontSize: "9.5pt",
    fontWeight: "bold",
  },
  smallText: {
    fontSize: "9pt",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px",
    backgroundColor: "#fff",
  },
  headerCell: {
    backgroundColor: "#F4F4F4",
    border: "1pt solid #3F4154",
    padding: "8px",
  },
  cell: {
    border: "1pt solid #3F4154",
    padding: "8px",
    backgroundColor: "#eff6ff",
  },
  rightAlign: {
    textAlign: "right",
  },
  centerAlign: {
    textAlign: "center",
  },
  signature: {
    marginTop: "50px",
    textAlign: "center",
  },
};

  const Header = () => {
    const country = bussiness?.country
      ? Country.getCountryByCode(bussiness.country)
      : null;
    const state = bussiness?.state
      ? State.getStateByCodeAndCountry(bussiness.state, bussiness.country)
      : null;

    // Customer country/state
    const customerCountry = item?.country
      ? Country.getCountryByCode(item.country)
      : null;
    const customerState = item?.state
      ? State.getStateByCodeAndCountry(item.state, item.country)
      : null;

    return (
      <table style={styles.table}>
        <tbody>
          <tr>
            {/* Left side: Logo + Business Name */}
            <td style={styles.cell}>
              <div className="flex items-center space-x-3">
                <div className="rounded-full overflow-hidden flex items-center justify-center bg-gray-100 shadow-md h-12 w-12">
                  <img
                    src={
                      bussiness?.businesslogo
                        ? AWS_URL + bussiness.businesslogo
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt="Logo"
                    className="h-full w-full object-contain"
                    // //crossOrigin="anonymous"
                  />
                </div>
                <div style={styles.heading}>{businessName}</div>
              </div>
            </td>

            {/* Right side: Phone, GSTIN, Email, Address */}
            <td style={{ ...styles.cell, textAlign: "right" }}>
              <div style={styles.normalText}>
                Phone: {phone || "0000000000"}
              </div>
              <div style={styles.normalText}>
                GSTIN: {bussiness?.gstNumber || "N/A"}
              </div>
              <div style={styles.normalText}>
                Email: {bussiness?.email || "N/A"}
              </div>
              <div style={styles.normalText}>
                Address:{" "}
                {bussiness?.firstLine
                  ? `${bussiness.firstLine}, ${state?.name || ""}, ${
                      country?.name || ""
                    }`
                  : "N/A"}
              </div>
            </td>
          </tr>

          <tr>
            <td style={styles.headerCell}>{t("NEWINVOICE.BILL_TO")}:</td>
            <td style={styles.headerCell}>
              {t("NEWINVOICE.INVOICE_DETAILS")}:
            </td>
          </tr>
          <tr>
            <td style={styles.cell}>
              <div style={styles.normalText}>{item?.customerName}</div>
              <div style={styles.normalText}>
                {t("NEWINVOICE.CONTACT_NO")}: {item?.mobile}
              </div>
              <div style={styles.normalText}>
                {t("NEWINVOICE.ADDRESS")}:{" "}
                {item?.address
                  ? `${item.address}, ${customerState?.name || ""}, ${
                      customerCountry?.name || ""
                    }`
                  : "N/A"}
              </div>
            </td>
            <td style={styles.cell}>
              <div style={styles.normalText}>
                {t("NEWINVOICE.NO")}: {item?.invoiceId}
              </div>
              <div style={styles.normalText}>
                {t("NEWINVOICE.DATE")}{" "}
                {SaleformatDateByBusinessPreference(
                  item?.saleDate,
                  bussiness?.dateFormat
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

 
const ItemsTable = () => {
  // calculate total discount
  const totalDiscount = item?.items?.reduce((acc, cur) => {
    const disc =
      cur.discountUnit === "₹"
        ? parseFloat(cur.discount || 0) // fixed discount
        : (parseFloat(cur.salePrice) * parseFloat(cur.discount || 0)) / 100; // % discount
    return acc + disc * cur.quantity;
  }, 0);

  return (
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.headerCell}>{t("NEWINVOICE.ITEM_NAME")}</th>
          <th style={styles.headerCell}>{t("NEWINVOICE.HSN_SAC")}</th>
          <th style={styles.headerCell}>{t("NEWINVOICE.QTY")}</th>
          <th style={styles.headerCell}>{t("NEWINVOICE.PRICE_PER_UNIT")}</th>
          <th style={styles.headerCell}>{t("NEWINVOICE.DISCOUNT")}</th>
          <th style={styles.headerCell}>{t("NEWINVOICE.GST")}</th>
          <th style={styles.headerCell}>{t("NEWINVOICE.AMOUNT")}</th>
        </tr>
      </thead>
      <tbody>
        {item?.invoiceId.startsWith("RT")
          ? item?.returnitems?.map((itm, index) => (
              <tr key={index}>
                <td style={styles.cell}>{itm?.productName}</td>
                <td style={styles.cell}>
                  {truncateCommaSeparatedString(itm?.hsnNumber)}
                </td>
                <td style={styles.cell}>{itm.quantity}</td>
                <td style={styles.cell}>{itm?.salePrice}</td>
                {/* discount with unit */}
                <td style={styles.cell}>
                  {itm?.discount} {itm?.discountUnit}
                </td>
                <td style={styles.cell}>{itm?.igst}%</td>
                <td style={styles.cell}>
                  {`${itm?.finalPrice} ${bussiness?.currency}`}
                </td>
              </tr>
            ))
          : item?.items?.map((itm, index) => (
              <tr key={index}>
                <td style={styles.cell}>{itm?.productName}</td>
                <td style={styles.cell}>
                  {truncateCommaSeparatedString(itm?.hsnNumber)}
                </td>
                <td style={styles.cell}>{itm.quantity}</td>
                <td style={styles.cell}>{itm?.salePrice}</td>
                {/* discount with unit */}
                <td style={styles.cell}>
                  {itm?.discount} {itm?.discountUnit}
                </td>
                <td style={styles.cell}>{itm?.igst}%</td>
                <td style={styles.cell}>
                  {`${itm?.finalPrice} ${bussiness?.currency}`}
                </td>
              </tr>
            ))}

        {/* Total row */}
        <tr>
          <td colSpan="4" style={{ ...styles.cell, ...styles.boldText }}>
            {t("NEWINVOICE.TOTAL")}
          </td>
          <td style={{ ...styles.cell, ...styles.boldText }}>
            -{totalDiscount} {bussiness?.currency}
          </td>
          <td style={styles.cell}>{item.igst} {bussiness?.currency}</td>
          <td style={{ ...styles.cell, ...styles.boldText }}>
            {item?.transactionAmount} {bussiness?.currency}
          </td>
        </tr>
      </tbody>
    </table>
  );
};




  const TaxSummary = () => (
    <table style={styles.table}>
      <tbody>
        <tr>
          <td colSpan="5" style={styles.cell}>
            {t("NEWINVOICE.TAX_SUMMARY")}:
          </td>
          <td style={styles.cell}>{t("NEWINVOICE.SUB_TOTAL")}</td>
          <td style={styles.cell}>{item?.transactionAmount}</td>
        </tr>
        {item?.cgst > 0 && (
          <tr>
            <td colSpan="5" style={{ ...styles.cell, ...styles.centerAlign }}>
              <span style={styles.boldText}>{t("TAX_WITHOUT_PERC.CGST")}</span>
            </td>
            <td style={styles.cell}>CGST Amount</td>
            <td style={styles.cell}>{parseFloat(item.cgst).toFixed(2)}</td>
          </tr>
        )}
        {item?.sgst > 0 && (
          <tr>
            <td colSpan="5" style={{ ...styles.cell, ...styles.centerAlign }}>
              <span style={styles.boldText}>{t("TAX_WITHOUT_PERC.SGST")}</span>
            </td>
            <td style={styles.cell}>SGST Amount</td>
            <td style={styles.cell}>{parseFloat(item.sgst).toFixed(2)}</td>
          </tr>
        )}
        {item?.igst > 0 && (
          <tr>
            <td colSpan="5" style={{ ...styles.cell, ...styles.centerAlign }}>
              <span style={styles.boldText}>{t("TAX_WITHOUT_PERC.IGST")}</span>
            </td>
            <td style={styles.cell}>IGST Amount</td>
            <td style={styles.cell}>{parseFloat(item.igst).toFixed(2)}</td>
          </tr>
        )}
        {item?.cess > 0 && (
          <tr>
            <td colSpan="5" style={{ ...styles.cell, ...styles.centerAlign }}>
              <span style={styles.boldText}>{t("TAX_WITHOUT_PERC.CESS")}</span>
            </td>
            <td style={styles.cell}>CESS Amount</td>
            <td style={styles.cell}>{parseFloat(item.cess).toFixed(2)}</td>
          </tr>
        )}
      </tbody>
    </table>
  );

  const HSNSummary = () => (
    <table style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.headerCell}>{t("NEWINVOICE.HSN_SAC")}</td>
          <td style={styles.headerCell}>{t("NEWINVOICE.TAXABLE_AMOUNT")}</td>
          <td style={styles.headerCell}>{t("NEWINVOICE.RATE")} (%)</td>
          <td style={styles.headerCell}>{t("NEWINVOICE.AMOUNT")}</td>
          <td style={styles.headerCell}>{t("NEWINVOICE.TOTAL_TAX")}</td>
          {/* <td colSpan='2' style={styles.headerCell}>
            {t("NEWINVOICE.AMOUNT_IN_WORDS")}:
          </td> */}
        </tr>
        {(item?.items?.length ? item.items : item.returnitems)?.map(
          (item, index) => (
            <tr key={index}>
              <td style={styles.cell}>
                {truncateCommaSeparatedString("1111,222,333")}
              </td>

              <td style={styles.cell}>{item?.salePrice}</td>
              <td style={styles.cell}>{calculateTotalGSTPercentage(item)}%</td>
              <td style={styles.cell}>{calculateTotalGSTAmount(item)}</td>
              <td style={styles.cell}>{calculateTotalGSTAmount(item)}</td>
              {/* <td colSpan='2' rowSpan='2' style={styles.cell}>
              {amountInwords}
            </td> */}
            </tr>
          )
        )}
      </tbody>
    </table>
  );

  // const PaymentSummary = () => (
  //   <table style={styles.table}>
  //     <tbody>
  //       <tr>
  //         <td colSpan='5' style={styles.cell}></td>
  //         <td style={styles.cell}>
  //           <div>Received</div>
  //           <div>Balance</div>
  //         </td>
  //         <td style={styles.cell}>
  //           <div>₹{payments.received.toFixed(3)}</div>
  //           <div>₹{payments.balance.toFixed(3)}</div>
  //         </td>
  //       </tr>
  //     </tbody>
  //   </table>
  // );

  const TermsAndSignature = () => (
    <table style={styles.table}>
      <tbody>
        <tr>
          <td style={styles.headerCell}>{t("NEWINVOICE.TERMS_CONDITIONS")}:</td>
        </tr>
        <tr>
          <td style={styles.cell}>{t("NEWINVOICE.THANKS_MESSAGE")}</td>
        </tr>
        <tr>
          <td style={styles.cell}>
            <div> {t("NEWINVOICE.FOR_COMPANY", { company: businessName })}</div>
            <div style={styles.signature}>
              <div style={styles.normalText}>
                {t("NEWINVOICE.AUTHORIZED_SIGNATORY")}
              </div>
              Authorized Signatory
              {bussiness.aadharPhoto && (
                <div class="flex w-1/2 p-4 bg-gray-100 rounded-lg">
                  <img
                    src={AWS_URL + bussiness.aadharPhoto}
                    alt="Payment QR Code"
                    class="w-30 object-contain"
                    // //crossOrigin="anonymous"
                  />
                </div>
              )}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );

  return (
    <div style={styles.container} ref={containerRef}>
      <h1 style={styles.title}>{t("NEWINVOICE.TAX_INVOICE")}</h1>
      <Header />
      <ItemsTable />
      <TaxSummary />
      <HSNSummary />
      {/* <PaymentSummary /> */}
      <TermsAndSignature />
    </div>
  );
};

TallyPrime.propTypes = {
  // businessDetails: PropTypes.shape({
  //   name: PropTypes.string.isRequired,
  //   phone: PropTypes.string.isRequired,
  // }),
  customerDetails: PropTypes.shape({
    name: PropTypes.string.isRequired,
    contact: PropTypes.string.isRequired,
  }),
  invoiceDetails: PropTypes.shape({
    number: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      hsn: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      pricePerUnit: PropTypes.number.isRequired,
      gst: PropTypes.number.isRequired,
      gstPercentage: PropTypes.number.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ),
  taxSummary: PropTypes.shape({
    subTotal: PropTypes.number.isRequired,
    igst: PropTypes.number.isRequired,
    totalTax: PropTypes.number.isRequired,
    amountInWords: PropTypes.string.isRequired,
  }),
  payments: PropTypes.shape({
    received: PropTypes.number.isRequired,
    balance: PropTypes.number.isRequired,
  }),
};

export default TallyPrime;
